import { Tag } from "antd";
import IMAGES from "../../../../../../assets/images";
import CustomDrawer from "../../../../../../components/CustomDrawer";
import CustomImage from "../../../../../../components/CustomImage";
import StatusTag from "../../../../../../components/StatusTag";

const INDICATOR_COLORS: { [key: string]: string } = {
  government: "#3E8BFF", // Blue
  festival: "#00C897", // Green
  events: "#C026D3", // Purple
  holiday: "#6B7280", // Gray
  leave: "#FACC15", // Yellow
};

const LEAVE_STATUS_CONFIG = [
  { label: "Pending", value: "pending", className: "status status-yellow" },
  { label: "Approved", value: "approved", className: "status status-success" },
  { label: "Rejected", value: "rejected", className: "status status-error" },
];
// utils/date.ts

function formatDate(dateString?: string | null): string {
  if (!dateString) return "";

  const date = new Date(dateString);

  // Get day, month, and year
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  return `${day} ${month}, ${year}`;
}

export default function EmployeeLeaveView({
  data,
  open,
  handleClose,
}: {
  data: any;
  type?: string;
  open: boolean;
  handleClose: (value?: boolean) => void;
}) {
  return (
    <>
      <CustomDrawer
        width={850}
        open={open}
        onClose={handleClose}
        title={`Date Details`}
      >
        <div>
          {data?.holidays && data.holidays.length > 0
            ? data.holidays.map((holiday: any, index: number) => {
                const holidayType =
                  holiday.type === "GOVERNMENT"
                    ? "Government Holiday"
                    : holiday.type === "HOLIDAY"
                    ? "Weekly Holiday"
                    : holiday.type === "FESTIVAL"
                    ? "Festival"
                    : holiday.type === "EVENTS"
                    ? "Event"
                    : "N/A";

                // Determine the outline color
                const outlineColor =
                  holiday.type === "GOVERNMENT"
                    ? INDICATOR_COLORS.government
                    : holiday.type === "HOLIDAY"
                    ? INDICATOR_COLORS.holiday
                    : holiday.type === "FESTIVAL"
                    ? INDICATOR_COLORS.festival
                    : holiday.type === "EVENTS"
                    ? INDICATOR_COLORS.events
                    : "#FFFFFF"; // fallback white

                const isLastHoliday = index === data.holidays.length - 1;
                const hideBorder = isLastHoliday && data?.leaves?.length === 0;

                return (
                  <div className="mb-10">
                    <div
                      className="w-full p-6 rounded-xl inline-flex justify-start items-center gap-2.5"
                      style={{
                        outline: `0.5px solid ${outlineColor}`,
                        outlineOffset: "-0.5px",
                      }}
                    >
                      <div className="inline-flex flex-col justify-center items-start gap-2.5">
                        <div className="justify-start text-white text-base font-bold">
                          {formatDate(data?.date)}
                        </div>
                        <div className="justify-start text-white text-2xl font-bold">
                          {holidayType}
                        </div>
                      </div>
                    </div>

                    <div className="mt-8">
                      <div className="justify-start text-white text-lg font-normal">
                        Name
                      </div>
                      <div className="justify-start text-white text-2xl font-normal mt-2">
                        {holiday.name || "N/A"}
                      </div>
                    </div>

                    <div
                      className={`mt-[16px] pb-[16px] ${
                        hideBorder ? "" : "border-b border-gray-700"
                      }`}
                    >
                      <div className="justify-start text-white text-lg font-normal">
                        Description
                      </div>
                      <div className="justify-start text-white text-base font-normal mt-2">
                        {holiday.description || "N/A"}
                      </div>
                    </div>
                  </div>
                );
              })
            : ""}
        </div>

        {data?.leaves?.length > 0 && (
          <div className="w-full p-6 rounded-xl outline outline-[0.50px] outline-offset-[-0.50px] outline-yellow-400 inline-flex justify-start items-center gap-2.5">
            <div className="inline-flex flex-col justify-center items-start gap-2.5">
              <div className="justify-start text-white text-base font-bold">
                {formatDate(data?.date)}
              </div>
              <div className="justify-start text-white text-2xl font-bold">
                Employee leave ({data?.leaves?.length || 0})
              </div>
            </div>
          </div>
        )}

        <div className="w-full mx-auto p-3">
          {(data?.leaves || []).map((item: any, index: number) => (
            <div
              key={item.employee.employee_id}
              className={`w-full bg-transparent mb-5 p-3 ${
                index === (data?.leaves?.length || 0) - 1
                  ? ""
                  : "border-b border-gray-700"
              }`}
            >
              <div className="flex items-center justify-between pb-4">
                {/* Left Profile */}
                <div className="flex items-center gap-4">
                  <CustomImage
                    size={56}
                    src={item.employee.photo}
                    placeholder={IMAGES.avatar}
                    className="w-14 h-14 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-xs text-gray-400">
                      ID #{item.employee.employee_id}
                    </p>

                    <div className="flex items-center gap-2">
                      <h2 className="text-lg font-semibold text-white">
                        {item.employee.name}
                      </h2>

                      <StatusTag
                        value={item.status}
                        config={LEAVE_STATUS_CONFIG}
                      />
                    </div>

                    <p className="text-sm text-gray-400">
                      {item.employee.designation}
                    </p>
                  </div>
                </div>

                {/* Right Section */}
                <div className="flex flex-col items-end gap-2">
                  <Tag
                    color="default"
                    className="border border-gray-500 text-gray-300 !bg-transparent"
                  >
                    {item.leave_type} Leave
                  </Tag>

                  <p className="text-sm text-gray-400">
                    Department :{" "}
                    <span className="text-gray-300">
                      {item.employee.department}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </CustomDrawer>
    </>
  );
}
